import React from 'react';
import BASE from '../assets/logo/BASE.png';

class ContactPage extends React.Component {
    
    // changes the title of the page
    componentDidMount() {
        document.title = 'Contact';
    }

    // main part
    render(){
        return (
            <div className='container'>
                <div className='contact'>
                    <div className='info'>
                        <img src={BASE} alt='base logo' />
                        <p>All BASE students are welcome to participate in any internships, summer jobs, learning events etc. listed in this website.<br/><br/>
                        Due to COVID-19, we will mostly work remotely. If you need help with your working papers, internships, time-sheets, or documents for learning events, feel free to send me an email and schedule an appointment for virtual meet on Zoom or Google Meet .<br/><br/>
                        Stay safe.<br/>Jon Mannion</p>
                    </div>

                    <div className='form-container'>
                        <div className='contact-intro'>
                            <h1>Contact</h1>
                            <p className='paragraph'>Please let me know if you have any question about the opportunities, or need help.</p>
                        </div>
                        <form action="/">
                            <label>Full Name</label>
                            <input type="text" id="name" name="name" placeholder="Your name.." required/>

                            <label>Email</label>
                            <input type="text" id="email" name="email" placeholder="Your email.." required />

                            <label>Message</label>
                            <textarea id="message" name="Message" placeholder="Write something" required />
                            <button type="submit" value="Submit">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default ContactPage;